const SIF = [
    {
      page: 2,
      lib: "Une 1ere énigme",
      texteIndice: ["Une enseigne", "Immobilière", "Le sel de la vie"]
    },
    {
      page: 4,
      lib: "Un panneau codé",
      texteIndice: [
        "Trouvez de quoi se désaltérer",
        "Un écriteau sur la fontaine, inspirez-vous en",
        "Félicitations continuez"
      ]
    },
    {
      page: 6,
      lib: "Des points bizarres",
      texteIndice: [
        "Regardez vos pieds",
        "Re-dessinez le cygne au sol",
        "La maison du cygne"
      ]
    },
    {
      page: 8,
      lib: "Un portail vers la verité",
      texteIndice: [
        "Cherchez l'indice manquant",
        "sur le portail",
        "pour selectionner le bon quart",
        "Q"
      ]
    },
    {
      page: 10,
      lib: "Orthografik",
      texteIndice: [
        "Trouvez sur le panneau",
        "Père ou pair ?",
        "La maison du cygne et le patio"
      ]
    },
    {
      page: 12,
      lib: "Ne pas être borné",
      texteIndice: ["Parfois en anglais", "Four(s) = 4 en anglais", "Fada"]
    },
    {
      page: 14,
      lib: "Les butineuses",
      texteIndice: [
        "Trouvez sur les abeilles",
        "Sur les tuiles",
        "Tuileries Romain Boyer"
      ]
    },
    {
      page: 16,
      //lib: "Ecran ou nacre ?",
      lib: "L'intru",
      texteIndice: [
        "L'intru n'est pas la girelle",
        "Ni le sar",
        "Réponse : La BAUDROIE (lettre B) n'est pas sur l'image"
      ]
    },
    {
      page: 18,
      //lib: "La devinette",
      lib: "La capitainerie",
      texteIndice: [
        "Anagramme",
        "CRANE => AN...",
        "Trouvez la petite plaque au pied de l'ANCRE",
        "Réponse : SLN"
      ]
    },
    {
      page: 20,
      //lib: "L'éléphant",
      lib: "Devinette florale",
      texteIndice: [
        "Une plante à trouver",
        "SUN DANCE",
        "La réponse est 'Leucospermum' ... Sun Dance (pelote d'épingle)"
      ]
    },
    {
      page: 22,
      lib: "Les clés",
      texteIndice: [
        "Pas besoin de chercher un trou de serrure",
        "Comparez les formes",
        "La clé 'U' est en forme du batiment"
      ]
    },
    {
      page: 24,
      lib: "Paysage",
      texteIndice: [
        "Utilisez la table",
        "Sur la table d'orientation, suivez la direction",
        "Solution : Iles Baléares"
      ]
    },
    {
      page: 26,
      lib: "Batterie",
      texteIndice: ["Regardez dans l'axe", "du canon", "Maquis"]
    },
    {
      page: 28,
      lib: "La plante",
      texteIndice: [
        "Aidez-vous du panneau",
        "Quelqu'un qui a peur de l'Europe",
        "Euphorbes"
      ]
    },
    {
      page: 30,
      lib: "L'origami",
      texteIndice: ["Pliez selon instructions", "réponse sur l'aile", "Paquet"]
    },
    {
      page: 33,
      lib: "L'héritier - dernière énigme !",
      texteIndice: [
        "Les balades",
        "Les plages de galets",
        "C'est Caroline la petite-fille !"
      ]
    }
  ];

export default SIF;